import React from 'react';

/** Top-down court drawing (flat vector, product identity) used behind the hero. */
export function CourtBackdrop({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 1200 600" preserveAspectRatio="xMidYMid slice" aria-hidden="true" className={className} data-id="element-82" data-mp="2lwmptb4htjr0">
      <rect x="0" y="0" width="1200" height="600" fill="#2563A6" opacity="0.10" data-id="element-83" data-mp="2quoag0hkhr4l" />
      {/* Kitchen (non-volley zone) shaded */}
      <rect x="460" y="70" width="280" height="460" fill="#2BB3A3" opacity="0.14" data-id="element-84" data-mp="1u79su006fo4z" />
      <g stroke="#FFFFFF" strokeOpacity="0.22" strokeWidth="4" fill="none" data-id="element-85" data-mp="1y7tu9frs9dwx">
        <rect x="80" y="70" width="1040" height="460" data-id="element-86" data-mp="235visg7za5fs" />
        <line x1="460" y1="70" x2="460" y2="530" data-id="element-87" data-mp="238hqqgys6myj" />
        <line x1="740" y1="70" x2="740" y2="530" data-id="element-88" data-mp="2869gp5fv7z03" />
        <line x1="80" y1="300" x2="460" y2="300" data-id="element-89" data-mp="282vim9e8ibyg" />
        <line x1="740" y1="300" x2="1120" y2="300" data-id="element-90" data-mp="3ekikkaai51l5" />
      </g>
      {/* Net */}
      <line x1="600" y1="50" x2="600" y2="550" stroke="#FFFFFF" strokeOpacity="0.45" strokeWidth="6" data-id="element-91" data-mp="3jjlrk0a1lhvr" />
      {/* Players (dots) and movement (solid arrows) */}
      <g fill="#FFFFFF" fillOpacity="0.35" data-id="element-92" data-mp="guqrk5ik95p6">
        <circle cx="200" cy="190" r="14" data-id="element-93" data-mp="cv834zrj6chl" />
        <circle cx="420" cy="420" r="14" data-id="element-94" data-mp="ctdizno32oek" />
        <circle cx="790" cy="180" r="14" data-id="element-95" data-mp="7vvi8kk7zfhn" />
        <circle cx="800" cy="420" r="14" data-id="element-96" data-mp="7uk4pt0z2tdc" />
      </g>
      <path d="M220 200 L390 260" stroke="#FFFFFF" strokeOpacity="0.3" strokeWidth="4" fill="none" data-id="element-97" data-mp="2xtpf7wzs1sz" />
      {/* Ball path (dashed) and ball (lime) */}
      <path d="M205 205 Q 480 40 780 400" stroke="#C6D430" strokeOpacity="0.55" strokeWidth="4" strokeDasharray="12 12" fill="none" data-id="element-98" data-mp="3u4wik4we4i5u" />
      <circle cx="780" cy="400" r="10" fill="#C6D430" fillOpacity="0.85" data-id="element-99" data-mp="3lbt69zxhebcs" />
    </svg>;
}